import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { BASE_API } from "../../Api"
import { ls } from "Helpers/LocalStorageEncrypt"

export const handleLogout = createAsyncThunk(
  "logout",
  async (_, { fulfillWithValue, rejectWithValue }) => {
    const response = await BASE_API.get("/user/logout")
    if (response?.status === 200) {
      return fulfillWithValue(response?.data)
    }
    return rejectWithValue(response)
  }
)
export const authMe = createAsyncThunk(
  "me",
  async (_, { fulfillWithValue, rejectWithValue }) => {
    const response = await BASE_API.get("/user/me")
    if (response?.status === 200) {
      return fulfillWithValue(response?.data)
    }
    return rejectWithValue(response)
  }
)
export const handleDeleteAccount = createAsyncThunk(
  "delete_account",
  async (_, { fulfillWithValue, rejectWithValue }) => {
    const response = await BASE_API.post("/user/deactivate-account")
    if (response?.status === 200) {
      return fulfillWithValue(response?.data)
    }
    return rejectWithValue(response)
  }
)

const initialState = {
  data: {},
  isLogin: false
}

export const user = createSlice({
    name: 'user',
    initialState,
    reducers: {
      updateProfile: (state, action) => {
        const { data , isLogin = true  } = action.payload
        state.isLogin = true 
        state.data = {...state.data , ...data?.user}
        if(isLogin){
          ls.setItem('token', data?.access_token)
          window.location.pathname = '/dashboard'
        }
      }
    },
    extraReducers: (builder) => {
      builder
      .addCase(authMe.fulfilled, (state, action) => {
        const { user , cart } = action.payload
        state.data = {...state.data , cart , ...user}
      }) 
      .addCase(authMe.rejected, (state , action) => {
        state.isLogin = false 
        state.data = {}
        window.location.pathname = '/'
        ls.removeItem('token')
      }) 
      .addCase(handleLogout.fulfilled, (state, action) => {
        state.isLogin = false 
        state.data = {}
        window.location.pathname = '/'
        ls.removeItem('token')
      }) 
      .addCase(handleLogout.rejected, (state) => {
        state.isLogin = false 
        state.data = {}
        window.location.pathname = '/'
        ls.removeItem('token')
      }) 
      .addCase(handleDeleteAccount.fulfilled, (state) => {
        state.isLogin = false
        state.data = {}
        window.location.pathname = '/'
        ls.removeItem('token')
      })
    }
})

export const { updateProfile } = user.actions

export default user.reducer
